import React, { useEffect } from 'react';
import classNames from 'classnames';
import LoadingDots from '../LoadingDots';
import '../../css/largeModal.css';
var LargeModal = function (props) {
    var active = props.active, className = props.className, closeModal = props.closeModal, children = props.children, headerText = props.headerText, id = props.id, processing = props.processing, subHeaderText = props.subHeaderText;
    useEffect(function () {
        if (active) {
            document.body.classList.add('overflow-off');
        }
        else {
            document.body.classList.remove('overflow-off');
        }
    }, [active]);
    var _backgroundClassName = classNames('large-modal-background', {
        'large-modal-background--active': active,
    });
    var _foregroundClassName = classNames('large-modal-foreground', className, {
        'large-modal-foreground--active': active,
    });
    return (React.createElement("div", { id: id || '', className: _backgroundClassName, onClick: closeModal },
        React.createElement("div", { className: _foregroundClassName, onClick: function (e) { e.stopPropagation(); } },
            React.createElement("div", { className: 'large-modal-header' },
                React.createElement("button", { className: 'large-modal-header__cancel', onClick: closeModal }, "\u2715"),
                subHeaderText && React.createElement("p", { className: 'large-modal-header__subheader' }, subHeaderText),
                React.createElement("h1", null, headerText)),
            processing
                ? React.createElement("div", { className: 'large-modal-loading' },
                    React.createElement(LoadingDots, { dotColor: 'clydeBlue', dotSize: 'large' }))
                : React.createElement("div", { className: 'large-modal-content' }, children))));
};
export default LargeModal;
